import { createSlice } from '@reduxjs/toolkit'

export const drawSlice = createSlice({
  name: 'draw',
  initialState: {
    value: false,
  },
  reducers: {
    toggleDraw: (state, action) => {
    
      state.value =!state.value
    },
   
  },
})

// Action creators are generated for each case reducer function
export const { toggleDraw } = drawSlice.actions

export default drawSlice.reducer